/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  DeletePersonProfilePictureParams
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getDeletePersonProfilePictureUrl = (params?: DeletePersonProfilePictureParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/persons/attachments/DeletePersonProfilePicture?${stringifiedParams}` : `/api/persons/attachments/DeletePersonProfilePicture`
}

export const deletePersonProfilePicture = async (params?: DeletePersonProfilePictureParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeletePersonProfilePictureUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDeletePersonProfilePictureMutationKey = () => ['deletePersonProfilePicture'] as const;

export const getDeletePersonProfilePictureMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePersonProfilePicture>>, TError,DeletePersonProfilePictureMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePersonProfilePicture>>, TError,DeletePersonProfilePictureMutationVariables, TContext> => {

const mutationKey = getDeletePersonProfilePictureMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePersonProfilePicture>>, DeletePersonProfilePictureMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  deletePersonProfilePicture(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePersonProfilePictureMutationResult = NonNullable<Awaited<ReturnType<typeof deletePersonProfilePicture>>>

    export type DeletePersonProfilePictureMutationError = ErrorType<unknown>
    export type DeletePersonProfilePictureMutationVariables = {params?: DeletePersonProfilePictureParams}

    export const useDeletePersonProfilePicture = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePersonProfilePicture>>, TError,DeletePersonProfilePictureMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePersonProfilePicture>>,
        TError,
        DeletePersonProfilePictureMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePersonProfilePictureMutationOptions(options), queryClient);
    }
